import { auth } from './firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { saveState } from './local-storage';
import type { AuthInfo } from '../actions/auth-actions';

interface LoginResult {
  user: {
    userId: string;
    avatar: string | null;
    name: string;
  };
}

class AuthService {
  logout(_userInfo: unknown): Promise<void> {
    saveState({});
    return signOut(auth);
  }

  login(authInfo: AuthInfo): Promise<LoginResult> {
    return signInWithEmailAndPassword(auth, authInfo.username, authInfo.password)
      .then((userCredential) => {
        const user = userCredential.user;
        return {
          user: {
            userId: user.uid,
            avatar: user.photoURL,
            name: user.displayName || user.email || 'Stasher',
          },
        };
      });
  }
}

export default AuthService;
